module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-fill-749bc999.svg";